import { render, staticRenderFns } from "./ForeignCompanyAddress.vue?vue&type=template&id=870b4e5a&scoped=true&"
import script from "./ForeignCompanyAddress.vue?vue&type=script&lang=js&"
export * from "./ForeignCompanyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870b4e5a",
  null
  
)

export default component.exports